// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"8b45b994","253":"9c876e05","317":"8b45b994","320":"3a12bcc4","518":"dab8592a","541":"8b45b994"}[chunkId] + ".chunk.css";
};